<script>
  import { onMount, beforeUpdate, afterUpdate } from 'svelte'
  import Gauge from 'svg-gauge'

  export let value = 0
  /**
   *  If displayValue is set, it becomes the label, and we set the 'real' value to 100 for the circle effect.
   *  @type {Number?}
   */
  export let displayValue = undefined
  /**
   * If store is set, extract its value 
   */
  export let store = undefined
  $: storeValue = store ? $store : undefined

  export let suffix = '' // to be appended to the label
  export let isDecimal = false

  // svg-gague api
  export let dialStartAngle = 135
  export let dialEndAngle = 45 // must be less than dialStartAngle
  export let radius = 40
  export let min = 0
  export let max = 100
  export let label = (value)=> {
    if(displayValue) {
      if(isDecimal){
        let tmp = displayValue.toFixed(2).toLocaleString("en-US")
        return tmp + suffix
      } else {
        return displayValue.toLocaleString("en-US") + suffix
      }
    } else {
      if(isDecimal){
        let tmp = value.toFixed(2).toLocaleString("en-US")
        return tmp + suffix
      } else {
        
        return Math.round(value).toLocaleString("en-US") + suffix
      }
    }
  }
  export let showValue = true
  export let gaugeClass = 'gauge'
  export let dialClass = 'dial'
  export let valueDialClass = 'value'
  export let valueClass = 'value-text'
  export let color = (value)=> {
    return '#e00122'
  }

  let gagueReference = undefined
  let gagueEle

  onMount(()=>{
    if(displayValue) { value = 100 }

    gagueReference = Gauge(gagueEle, {
      min: min,
      max: max,
      dialStartAngle: dialStartAngle,
      dialEndAngle: dialEndAngle,
      label: label,
      value: 0,
      radius: radius,
      color: color,
      showValue: showValue,
      gaugeClass: gaugeClass,
      dialClass: dialClass,
      valueDialClass: valueDialClass,
      valueClass: valueClass,
    })
  })

  afterUpdate(()=>{
    if(storeValue) {
      // we're using a store. Must have a truthy displayValue to use the store as the label
      if(displayValue) {
        displayValue = storeValue
      } else {
        value = storeValue
      }
    } else if(value) {
      gagueReference.setValueAnimated(value, 1)
    }
    
  })
</script>

<div class="gauge" bind:this={ gagueEle }></div>